import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { IconButton } from '../ui/IconButton'
import { Icon } from '../ui/Icon'
import { ImportButton } from './ImportButton'
import { CopyButton } from './CopyButton'
import { ExportButton } from './ExportButton'
import { FullScreenPreviewButton } from '../preview/FullScreenPreviewButton'
import { MoreMenu } from './MoreMenu'

/**
 * 顶部导航栏组件
 * 包含应用标题、主题切换、导入导出分享按钮、语言切换器
 */
export const Topbar = React.memo(() => {
  const { t } = useTranslation()
  const { toggleSidebar, isSidebarVisible } = useAppStore()

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-light)'
      }}
    >
      <div className="flex items-center justify-between h-14 px-4">
        {/* 左侧：侧边栏切换按钮和应用标题 */}
        <div className="flex items-center space-x-3">
          <IconButton
            icon={<Icon name={isSidebarVisible ? 'sidebar-close' : 'sidebar-open'} size={24} />}
            onClick={toggleSidebar}
            variant="ghost"
            size="md"
            aria-label={t('nav.toggleSidebar')}
          />
          <h1
            className="text-lg font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            {t('app.name')}
          </h1>
          <div className="hidden md:block ml-2">
            <ImportButton />
          </div>
        </div>

        {/* 右侧：工具按钮 */}
        <div className="flex items-center space-x-2">
          <FullScreenPreviewButton />
          <div className="hidden md:flex items-center space-x-2">
            <CopyButton />
          </div>
          <ExportButton />
          <MoreMenu />
        </div>
      </div>
    </header>
  )
})